const SubMenu = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "sub_menu_icon": 'Icon',
    "main_menu": "Main Menu",
    "priority": "Priority",
    "search": "Search",

    // PAGE HEADER
    "sub_menu": "Sub Menu",

    // ERROR
    "error_name": "Enter Name",
    "error_desc": "Enter Description",
    "error_priority_positive": "Priority Should be Positive",
    "error_priority_required": "Enter Priority",
    "error_priority_type_error": "Enter only Number",
    "error_main_menu": "Select Main Menu",
    "error_icon": "Enter Icon Name",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_main_menu": "MAIN MENU",
    "table_description": "DESCRIPTION",
    "table_priority": "PRIORITY",

}

export default SubMenu